import { BaseballIncidentId } from '@collector/sportsapi-client-legacy'

export type BaseballBaseIncidentId =
  | BaseballIncidentId.FirstBase
  | BaseballIncidentId.SecondBase
  | BaseballIncidentId.ThirdBase

export function getBaseOffIncidentId(
  baseIncidentId: BaseballBaseIncidentId,
): BaseballIncidentId {
  switch (baseIncidentId) {
    case BaseballIncidentId.FirstBase:
      return BaseballIncidentId.FirstBaseOff
    case BaseballIncidentId.SecondBase:
      return BaseballIncidentId.SecondBaseOff
    case BaseballIncidentId.ThirdBase:
      return BaseballIncidentId.ThirdBaseOff
  }
}

export function getBaseIncidentIdFromOff(
  incidentId: BaseballIncidentId,
): BaseballBaseIncidentId | null {
  switch (incidentId) {
    case BaseballIncidentId.FirstBaseOff:
      return BaseballIncidentId.FirstBase
    case BaseballIncidentId.SecondBaseOff:
      return BaseballIncidentId.SecondBase
    case BaseballIncidentId.ThirdBaseOff:
      return BaseballIncidentId.ThirdBase
    default:
      return null
  }
}
